/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'share': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M14.25 5.25a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zM16.5 9a3.739 3.739 0 01-2.685-1.132l-4.318 2.775c.163.421.253.879.253 1.357s-.09.936-.253 1.357l4.318 2.775a3.75 3.75 0 11-.812 1.261l-4.318-2.775a3.75 3.75 0 110-5.236l4.318-2.775A3.75 3.75 0 1116.5 9zm-8.59 4.191a.872.872 0 00-.033.05 2.25 2.25 0 11.032-.05zm6.684 4.363a2.25 2.25 0 103.812 2.393 2.25 2.25 0 00-3.812-2.393z" _fill="#000"/>'
  }
})
